// extracted by mini-css-extract-plugin
export default {"image":"EX-z","loaded":"FX-z"};